import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import {
    Button,
    Link,
    Icon,
    NotificationItem,
    NotificationItemInfo,
} from 'yurstrap';
import {
    hideNotificationsCenter,
    showNotificationsCenter,
    removeNotification,
} from '../../services/Notifications';

import NotificationsModal from './NotificationsModal';

const propTypes = {
    NotificationsActions: PropTypes.shape({
        hideNotificationsCenter: PropTypes.func.isRequired,
        showNotificationsCenter: PropTypes.func.isRequired,
        removeNotification: PropTypes.func.isRequired,
    }).isRequired,
    bulkNotifications: PropTypes.arrayOf(PropTypes.object).isRequired,
    bulkName: PropTypes.string.isRequired,
    notificationsCenterDisplayed: PropTypes.bool.isRequired,
    withI18N: PropTypes.bool,
};

const defaultProps = {
    withI18N: false,
};

export class NotificationsBulk extends Component {

    constructor(props) {
        super(props);
        this.removeNotification = this.removeNotification.bind(this);
        this.removeNotifications = this.removeNotifications.bind(this);
        this.hideNotificationsCenter = this.hideNotificationsCenter.bind(this);
        this.showNotificationsCenter = this.showNotificationsCenter.bind(this);
    }

    getBulkState() {
        const { bulkNotifications } = this.props;
        return _.reduce(bulkNotifications, (currentState, notification) => {
            if (notification.state === 'pending') {
                return notification.state;
            }
            if (notification.state === 'error'
                 && currentState !== 'pending') {
                return notification.state;
            }
            return currentState;
        }, 'success');
    }

    removeNotification(id) {
        const { NotificationsActions } = this.props;
        NotificationsActions.removeNotification(id);
    }

    removeNotifications() {
        const { bulkNotifications, NotificationsActions } = this.props;
        _.each(bulkNotifications, (bulkNotification) => {
            NotificationsActions.removeNotification(bulkNotification.id);
        });
    }

    hideNotificationsCenter() {
        const { NotificationsActions } = this.props;
        NotificationsActions.hideNotificationsCenter();
    }

    showNotificationsCenter() {
        const { NotificationsActions } = this.props;
        NotificationsActions.showNotificationsCenter();
    }

    renderNotificationLink(state, counters) {
        switch (state) {
            case 'success':
                return (
                    <Link
                        inline
                        color="white"
                        onClick={this.showNotificationsCenter}
                    >
                        Afficher les détails
                    </Link>
                );
            case 'error':
                return (
                    <Link
                        inline
                        color="white"
                        onClick={this.showNotificationsCenter}
                    >
                        Afficher les détails
                    </Link>
                );
            default:
                return (
                    <Link
                        inline
                        color="white"
                        onClick={this.showNotificationsCenter}
                    >
                        {counters[state]}
                        {' '}
                        opération
                        {counters[state] > 1 ? 's' : ''}
                        {' '}
                        en cours...
                    </Link>
                );
        }
    }

    renderModal() {
        const {
            bulkName,
            notificationsCenterDisplayed,
            withI18N,
        } = this.props;
        if (!notificationsCenterDisplayed) return null;
        return (
            <NotificationsModal
                bulkName={bulkName}
                onClose={this.hideNotificationsCenter}
                withI18N={withI18N}
            />
        );
    }

    renderBulkName() {
        const {
            bulkName,
            withI18N,
        } = this.props;
        if (!withI18N) return bulkName;
        return (
            <FormattedMessage id={bulkName} />
        );
    }

    render() {
        const { bulkNotifications } = this.props;
        const counters = {
            pending: 0,
            success: 0,
            error: 0,
        };
        const bulkState = _.reduce(bulkNotifications, (currentState, notification) => {
            counters[notification.state] += 1;
            if (notification.state === 'pending') {
                return notification.state;
            }
            if (notification.state === 'error'
             && currentState !== 'pending') {
                return notification.state;
            }
            return currentState;
        }, 'success');
        return (
            <NotificationItem state={bulkState}>
                {this.renderModal()}
                <NotificationItemInfo>
                    {this.renderBulkName()}
                </NotificationItemInfo>
                {this.renderNotificationLink(bulkState, counters)}
                <Button
                    square
                    color="tertiary"
                    onClick={this.removeNotifications}
                >
                    <Icon collection="yp" icon="close" />
                </Button>
            </NotificationItem>
        );
    }

}

NotificationsBulk.propTypes = propTypes;

NotificationsBulk.defaultProps = defaultProps;

function mapStateToProps(state, ownProps) {
    return {
        bulkNotifications: _.filter(state.Notifications.notifications, {
            bulkName: ownProps.bulkName,
        }),
        notificationsCenterDisplayed: state.Notifications.notificationsCenterDisplayed,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        NotificationsActions: bindActionCreators({
            hideNotificationsCenter,
            showNotificationsCenter,
            removeNotification,
        }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsBulk);
